import { render, staticRenderFns } from "./ReservasView.vue?vue&type=template&id=166a3eed&scoped=true"
import script from "./ReservasView.vue?vue&type=script&lang=js"
export * from "./ReservasView.vue?vue&type=script&lang=js"
import style0 from "./ReservasView.vue?vue&type=style&index=0&id=166a3eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a3eed",
  null
  
)

export default component.exports